const zh_Hk = {
  10000001: 'SuperEx 二週年慶典',
  10000002: '簽到領取豐厚獎勵！',
  10000003: '根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高10,000USDT獎金池',
  10000004: 'SuperEx 兩週年',
  10000005: '合約慶典賽贏取20,000USDT',
  10000006: `交易量排名賽，解鎖最高 <span style="color: #ffc72b;">10,000</span> USDT 獎金池`,
  10000007: '合約冠軍賽',
  10000008: '贏取20,000USDT獎池！',
}
export default zh_Hk



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/zh-HK.js